<template>
  <div>
    <Loading :isActive="loading" />
    <SeletorClientesAvancado
      :visible="seletorVisible"
      @close="seletorVisible = false"
      @confirm="onSeletorConfirm"
    />

    <div class="cabecalho">
      <div>
        <h4>Cadastro em massa de colaboradores</h4>
        <small class="text-muted">
          Cadastre vários colaboradores de uma vez, manualmente ou importando uma planilha.
        </small>
      </div>
      <button class="button" @click="voltar">
        <fa-icon icon="angle-double-left" /> Voltar
      </button>
    </div>

    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Manual" @click.native="modo = 'manual'">
        <div class="acoes-topo">
          <button class="button button-success" @click="adicionarLinha">
            <fa-icon icon="plus" /> Adicionar linha
          </button>
          <span class="text-muted">{{ linhas.length }} colaborador(es)</span>
        </div>

        <div class="listagem__table-wrapper">
          <table class="listagem__table">
            <thead>
              <tr>
                <th style="width: 18%">Tipo *</th>
                <th style="width: 24%">Nome *</th>
                <th style="width: 24%">E-mail *</th>
                <th style="width: 16%">Perfil *</th>
                <th style="width: 12%">Clientes</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(linha, index) in linhas" :key="index">
                <td>
                  <select v-model="linha.tipoId" class="form-control">
                    <option :value="null">Selecione</option>
                    <option v-for="t in tipos" :key="t.id" :value="t.id">
                      {{ t.desc }}
                    </option>
                  </select>
                </td>
                <td><input v-model="linha.nome" type="text" class="form-control" /></td>
                <td><input v-model="linha.email" type="email" class="form-control" /></td>
                <td>
                  <select v-model="linha.perfil" class="form-control">
                    <option :value="null">Selecione</option>
                    <option
                      v-for="p in perfisPara(linha.tipoId)"
                      :key="p.id"
                      :value="p.id"
                    >
                      {{ p.descricao }}
                    </option>
                  </select>
                </td>
                <td>
                  <button class="button button-link" @click="abrirSeletor(index)">
                    <fa-icon icon="search" />
                    {{ linha.clientes.length ? linha.clientes.length + " sel." : "Selecionar" }}
                  </button>
                </td>
                <td class="listagem__cell--actions">
                  <button class="button button-error" @click="removerLinha(index)">
                    <fa-icon icon="trash-alt" />
                  </button>
                </td>
              </tr>
              <tr v-if="!linhas.length">
                <td colspan="6" class="text-center text-muted" style="padding: 24px">
                  Nenhuma linha. Clique em "Adicionar linha" para começar.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="acoes-rodape">
          <button
            class="button button-primary"
            :disabled="!linhas.length"
            @click="enviarManual"
          >
            Cadastrar {{ linhas.length }} colaborador(es)
          </button>
        </div>
      </CTab>

      <CTab title="Importar planilha" @click.native="modo = 'importar'">
        <div class="import-topo">
          <button class="button" @click="baixarModelo">
            <fa-icon icon="download" /> Baixar modelo (CSV)
          </button>
          <label class="button button-primary">
            <fa-icon icon="file-upload" /> Escolher arquivo
            <input
              type="file"
              accept=".csv,.xls,.xlsx"
              style="display: none"
              @change="onArquivo"
            />
          </label>
          <span v-if="arquivoNome" class="text-muted">{{ arquivoNome }}</span>
        </div>

        <div v-if="previewLinhas.length" class="listagem__table-wrapper">
          <table class="listagem__table">
            <thead>
              <tr>
                <th>#</th>
                <th>Tipo</th>
                <th>Nome</th>
                <th>E-mail</th>
                <th>Perfil</th>
                <th>Clientes</th>
                <th>Situação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="linha in previewLinhas"
                :key="linha.linha"
                :class="{ 'linha-erro': linha.erros.length }"
              >
                <td>{{ linha.linha }}</td>
                <td>{{ linha.tipo }}</td>
                <td>{{ linha.nome }}</td>
                <td>{{ linha.email }}</td>
                <td>{{ linha.perfilDescricao }}</td>
                <td>{{ linha.clientes.length }}</td>
                <td>
                  <span v-if="!linha.erros.length" class="badge badge-success">OK</span>
                  <span v-else class="badge badge-danger" :title="linha.erros.join('; ')">
                    {{ linha.erros.length }} erro(s)
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="previewLinhas.length" class="acoes-rodape">
          <span class="text-muted">
            {{ previewValidas }} válida(s), {{ previewLinhas.length - previewValidas }} com erro
          </span>
          <button
            class="button button-primary"
            :disabled="!previewValidas"
            @click="confirmarImportacao"
          >
            Importar {{ previewValidas }} válida(s)
          </button>
        </div>
      </CTab>
    </CTabs>

    <div v-if="relatorio" class="relatorio">
      <h5>Resultado</h5>
      <p>
        <strong>{{ relatorio.criados }}</strong> criado(s),
        <strong>{{ relatorio.falhas }}</strong> falha(s) de {{ relatorio.total }}.
      </p>
      <ul v-if="relatorio.falhas">
        <li v-for="r in falhasRelatorio" :key="r.linha">
          Linha {{ r.linha }} ({{ r.email || "sem e-mail" }}): {{ r.erros.join("; ") }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { get, post, open } from "../../helpers/apiRequest";
import Loading from "../../components/Loading";
import SeletorClientesAvancado from "./components/SeletorClientesAvancado";

const novaLinha = () => ({
  tipoId: null,
  nome: "",
  email: "",
  perfil: null,
  clientes: [],
});

export default {
  name: "cadastro-em-massa-colaboradores",
  components: { Loading, SeletorClientesAvancado },
  data() {
    return {
      modo: "manual",
      loading: false,
      tipos: [],
      perfis: [],
      linhas: [novaLinha()],
      seletorVisible: false,
      seletorAlvo: null,
      arquivoNome: "",
      previewLinhas: [],
      relatorio: null,
    };
  },
  computed: {
    previewValidas() {
      return this.previewLinhas.filter((l) => !l.erros.length).length;
    },
    falhasRelatorio() {
      return this.relatorio ? this.relatorio.resultados.filter((r) => !r.sucesso) : [];
    },
  },
  methods: {
    voltar() {
      this.$router.push("/cadastros/colaboradores");
    },
    perfisPara(tipoId) {
      if (!tipoId) {
        return this.perfis;
      }
      const filtrados = this.perfis.filter(
        (p) => Array.isArray(p.perfisTipos) && p.perfisTipos.includes(tipoId)
      );
      return filtrados.length ? filtrados : this.perfis;
    },
    loadTipos() {
      get("/admin/tipos-colaborador")
        .then((json) => (this.tipos = json))
        .catch(() => {});
    },
    loadPerfis() {
      get("/admin/perfis-colaborador")
        .then((json) => (this.perfis = json))
        .catch(() => {});
    },
    adicionarLinha() {
      this.linhas.push(novaLinha());
    },
    removerLinha(index) {
      this.linhas.splice(index, 1);
    },
    abrirSeletor(index) {
      this.seletorAlvo = index;
      this.seletorVisible = true;
    },
    onSeletorConfirm({ ids }) {
      if (this.seletorAlvo !== null && this.linhas[this.seletorAlvo]) {
        this.linhas[this.seletorAlvo].clientes = ids;
      }
      this.seletorVisible = false;
      this.seletorAlvo = null;
    },
    enviarManual() {
      const colaboradores = this.linhas
        .filter((l) => l.nome || l.email || l.tipoId)
        .map((l, i) => ({
          linha: i + 1,
          tipoId: l.tipoId,
          nome: l.nome,
          email: l.email,
          perfil: l.perfil,
          clientes: l.clientes,
        }));

      if (!colaboradores.length) {
        return;
      }

      this.loading = true;
      this.relatorio = null;
      post("/admin/colaboradores/lote", { colaboradores })
        .then((json) => {
          this.relatorio = json.data;
          if (json.data.criados) {
            this.$swal({
              title: "Concluído",
              text: `${json.data.criados} colaborador(es) criado(s).`,
              icon: json.data.falhas ? "warning" : "success",
            });
          }
          if (!json.data.falhas) {
            this.linhas = [novaLinha()];
          }
        })
        .catch((err) => this.$swal({ title: "Erro", text: err.message, icon: "error" }))
        .finally(() => (this.loading = false));
    },
    baixarModelo() {
      open({ url: "/admin/colaboradores/lote/modelo" });
    },
    onArquivo(event) {
      const arquivo = event.target.files[0];
      if (!arquivo) {
        return;
      }
      this.arquivoNome = arquivo.name;
      const formData = new FormData();
      formData.append("arquivo", arquivo, arquivo.name);

      this.loading = true;
      this.previewLinhas = [];
      this.relatorio = null;
      post("/admin/colaboradores/lote/preview", formData, { isFile: true })
        .then((json) => {
          this.previewLinhas = json.data.linhas;
        })
        .catch((err) => this.$swal({ title: "Erro ao ler arquivo", text: err.message, icon: "error" }))
        .finally(() => (this.loading = false));
      event.target.value = "";
    },
    confirmarImportacao() {
      const colaboradores = this.previewLinhas
        .filter((l) => !l.erros.length)
        .map((l) => ({
          linha: l.linha,
          tipoId: l.tipoId,
          nome: l.nome,
          email: l.email,
          perfil: l.perfil,
          clientes: l.clientes,
        }));

      if (!colaboradores.length) {
        return;
      }

      this.loading = true;
      post("/admin/colaboradores/lote", { colaboradores })
        .then((json) => {
          this.relatorio = json.data;
          this.previewLinhas = [];
          this.arquivoNome = "";
          this.$swal({
            title: "Importação concluída",
            text: `${json.data.criados} criado(s), ${json.data.falhas} falha(s).`,
            icon: json.data.falhas ? "warning" : "success",
          });
        })
        .catch((err) => this.$swal({ title: "Erro", text: err.message, icon: "error" }))
        .finally(() => (this.loading = false));
    },
  },
  beforeMount() {
    this.loadTipos();
    this.loadPerfis();
  },
};
</script>

<style scoped>
.cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.cabecalho h4 {
  margin: 0;
}
.acoes-topo,
.import-topo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  flex-wrap: wrap;
}
.acoes-rodape {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
}
.listagem__table-wrapper {
  border: 1px solid #e4e7ea;
  border-radius: 10px;
  overflow-x: auto;
}
.listagem__table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  font-size: 13px;
}
.listagem__table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7ea;
}
.listagem__table thead th {
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #667085;
  text-align: left;
}
.listagem__table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}
.listagem__cell--actions {
  text-align: right;
}
.linha-erro {
  background: #fff5f5;
}
.button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d0d5dd;
  background: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
}
.button-primary {
  background: #004f6f;
  color: #fff;
  border-color: #004f6f;
}
.button-success {
  background: #2eb85c;
  color: #fff;
  border-color: #2eb85c;
}
.button-error {
  background: #e55353;
  color: #fff;
  border-color: #e55353;
  padding: 6px 10px;
}
.button-link {
  border: none;
  background: none;
  color: #004f6f;
  padding: 4px 6px;
}
.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.badge {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}
.badge-success {
  background: #d4f7e0;
  color: #1b7a3d;
}
.badge-danger {
  background: #fbd5d5;
  color: #a12020;
  cursor: help;
}
.relatorio {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #e4e7ea;
  border-radius: 10px;
  background: #fbfcfd;
}
.relatorio ul {
  margin: 8px 0 0;
  padding-left: 18px;
  color: #a12020;
  font-size: 13px;
}
</style>
